import { kebabCase } from 'lodash'

export function createAlertId(str: string) {
  return kebabCase(str).substring(0, 500)
}
